import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { useTranslation } from "react-i18next";

interface EmojiPickerProps {
  onClickOutside: () => void;
  onEmojiSelect: (emoji: string) => void;
}

export const EmojiPicker: React.FC<EmojiPickerProps> = ({ onClickOutside, onEmojiSelect }) => {
  const { i18n } = useTranslation();

  return (
    <Picker
      data={data}
      i18n={i18n.language === "sv-SE" ? emojiPickerI18nSv : undefined}
      onClickOutside={onClickOutside}
      // TODO: EmojiMart does not have types for this
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onEmojiSelect={(emoji: any) => onEmojiSelect(emoji.native)}
      perLine={6}
      previewPosition="none"
      skinTonePosition="none"
      theme="light"
    />
  );
};

// TODO: Remove when supported by @emoji-mart/react
export const emojiPickerI18nSv = {
  search: "Sök",
  clear: "Rensa",
  notfound: "Inga emojis hittades",
  categories: {
    search: "Sökresultat",
    recent: "Senaste",
    smileys: "Smileys",
    people: "Smileys & Människor",
    nature: "Djur & Natur",
    foods: "Mat & Dryck",
    activity: "Aktivitet",
    places: "Resor & Platser",
    objects: "Objekt",
    symbols: "Symboler",
    flags: "Flaggor",
    custom: "Anpassade",
  },
};
